var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"funnel canvas-funnel-container"},[_c('canvas',{ref:"funnelCanvas",attrs:{"width":"1280","height":"1200"}})])}
var staticRenderFns = []

export { render, staticRenderFns }